import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { CompanyStore } from '../store/company.store';

export const MainHomeGuard: CanActivateFn = () => {
  const viewConfig = inject(CompanyStore).viewConfigSignal();
  if ('enable' in viewConfig?.main_screen) {
    return viewConfig?.main_screen?.enable;
  } else {
    return true;
  }
};
